import type {
  AvailabilityTierModeUpdateRequestType,
  AvailabilityTierModeUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useAvailabilityTierModeUpdate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: AvailabilityTierModeUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: "availability-tiers/mode",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as AvailabilityTierModeUpdateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Suppliers,
          business?.Supplier?.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.AvailabilityTiers],
      });
    },
  });
};
